import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import {
	getCheckoutItems,
	getCheckoutItemsFulfilledAction,
	getCheckoutItemsPendingAction,
	getCheckoutItemsRejectedAction,
} from './thunks/getCheckoutItems';
import {
	getSummary,
	getSummaryFulfilledAction,
	getSummaryPendingAction,
	getSummaryRejectedAction,
} from './thunks/getSummary';
import {
	updateCheckoutItem,
	updateCheckoutItemFulfilledAction,
	updateCheckoutItemPendingAction,
	updateCheckoutItemRejectedAction,
} from './thunks/updateCheckoutItem';

export const checkoutItemsAdapter = createEntityAdapter();

export const initialState = checkoutItemsAdapter.getInitialState({
	isLoading: true,
	items: [],
	orderSummary: {
		isLoading: false,
		sections: {
			mainSummary: [],
			checkoutSummary: {},
			savedForLaterSummary: {},
		},
	},
});

export const checkoutSlice = createSlice({
	name: 'checkout',
	initialState,
	reducers: {
		removePendingDocument(state, { payload: documentId }) {
			Object.values(state.entities).forEach((checkoutItem) => {
				if (checkoutItem?.pending_documents) {
					checkoutItem.pending_documents = checkoutItem.pending_documents.filter(
						({ id }) => id !== documentId,
					);
				}
			});

			const pendingDocuments = state.orderSummary.sections.mainSummary?.pending_documents;
			if (pendingDocuments) {
				state.orderSummary.sections.mainSummary.pending_documents = pendingDocuments.filter(
					({ id }) => id !== documentId,
				);
			}
		},
	},
	extraReducers: (builder) => {
		builder.addCase(getCheckoutItems.pending, getCheckoutItemsPendingAction);
		builder.addCase(getCheckoutItems.fulfilled, getCheckoutItemsFulfilledAction);
		builder.addCase(getCheckoutItems.rejected, getCheckoutItemsRejectedAction);
		builder.addCase(getSummary.pending, getSummaryPendingAction);
		builder.addCase(getSummary.fulfilled, getSummaryFulfilledAction);
		builder.addCase(getSummary.rejected, getSummaryRejectedAction);
		builder.addCase(updateCheckoutItem.pending, updateCheckoutItemPendingAction);
		builder.addCase(updateCheckoutItem.fulfilled, updateCheckoutItemFulfilledAction);
		builder.addCase(updateCheckoutItem.rejected, updateCheckoutItemRejectedAction);
	},
});

export const checkoutSliceActions = checkoutSlice.actions;
export const { removePendingDocument } = checkoutSlice.actions;
export default checkoutSlice.reducer;
